<div id="divheader">
  <div class="content-container nav_desktop">
    <div class="pure-g">
      <div class="pure-u-11-24">
        <div class="logo_sec">
          <div class="pure-u-14-24">
            <a class="pluslogo" routerLink="/home" title="CSLB Plus logo">
              <!-- <img src="/assets/img/cslplus_logo.png" alt="CSLB Plus logo" class="" /> -->
            </a>
          </div>
          <div class="pure-u-4-24"></div>
          <div class="pure-u-4-24 langlink mobilehidden">
            <a routerLink="/fr/home" title="Français">Français</a>
          </div>
        </div>
      </div>
      <div class="pure-u-13-24">
        <div class="nav-tab mobilehidden">
          <p>Contact us at <a href="tel:1-888-490-4105">1-888-490-4105</a></p>
          <span>|</span>
          <p>Monday to Friday, 8 AM-8 PM EST</p>
          <span>|</span>
          <p><a href="mailto:support@cslplus.ca" title="Email Us">Email Us</a></p>
        </div>
        <div class="nav_icon desktophidden">
          <a id="navhaem" href="javascript:void(0);" class="icon" (click)="navmobile()"
             [style.display]="navhaem ? 'block' : 'none'">
            <span id="navMobile"><span class="fa fa-bars" aria-hidden="true" id="hamburger"></span></span>
          </a>
        </div>
      </div>
    </div>

    <div class="pure-g mobilehidden">
      <div class="pure-u-1 menu_tab ">
        <ul>
          <li><a (click)="scroll('#patinet_support')" title="Patients">Patients</a></li>
          <li><a (click)="scroll('#HCPS')" title="Healthcare Professionals">Healthcare Professionals</a></li>
          <li><a (click)="scroll('#sec_cslnews')" title="Order Supplies">Order Supplies</a></li>
          <li><a (click)="scroll('#contactus')" title="Contact Us">Contact Us</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="pure-u-1 desktophidden mobile_nav_panel">
    <div id="myLinks" class="topnav content-container" [style.display]="myLinks ? 'block' : 'none'">
      <div class="img_wrapper">
        <div class="pure-u-18-24 idelvionlogo">
          <a class="pluslogo" routerLink="/home" title="CSLB Plus logo">
            <img src="/assets/img/cslb-Plus-logo.svg" alt="CSLB Plus logo" class="" />
          </a>
        </div>
        <a id="" href="javascript:void(0);" class="pure-u-6-24" (click)="navmobile()">
          <span class="fa fa-close"></span>
        </a>
      </div>
      <div class="anchorwrapper">
        <ul>
          <li><a (click)="scroll('#patinet_support')" title="Patients">Patients</a></li>
          <li><a (click)="scroll('#HCPS')" title="Healthcare Professionals">Healthcare Professionals</a></li>
          <li><a (click)="scroll('#sec_cslnews')" title="Order Supplies">Order Supplies</a></li>
          <li><a (click)="scroll('#contactus')" title="Contact Us">Contact Us</a></li>
        </ul>
      </div>
      <div class="nav-tab-mobile">
        <div class="nav_wrapper">
          <p>Contact us at <a href="tel:1-888-490-4105" title="1-888-490-4105">1-888-490-4105</a></p>
          <p>Monday to Friday, 8 AM-8 PM EST</p>
          <p id="emaillink"><a href="mailto:support@cslplus.ca" title="Email Us">Email Us</a></p>

          <div class="langlink">
            <a routerLink="/fr/home" title="Français">Français</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="banner_header">
    <div class="pure-g">
      <div class="pure-u-1 pure-u-lg-2-24 pure-u-md-1-24 pure-u-xl-2-24"></div>
      <div class="pure-u-1 pure-u-lg-11-24 pure-u-md-11-24">
        <div class="content">
          <h1>
            CSL PLUS<sup>&trade;</sup> Patient Support Program:
          </h1>
          <h2>
            A personalized support program designed with patients in mind
          </h2>
          <p>
            CSL PLUS is dedicated to delivering the highest quality of support through one-to-one contact with our team
            of
            Registered Nurse Case Managers who are there for patients
            every step of the way.
          </p>
          <!-- </div> -->


        </div>
      </div>
      <div class="pure-u-1 pure-u-lg-11-24 pure-u-md-12-24 pure-u-xl-11-24">
        <video class="hero_video" src="assets/hero_video.mp4" type="video/mp4" playsinline autoplay [muted]="true"></video>
      </div>
    </div>
  </div>
  <!-- <div class="content-container">
    <div class="pure-g">
      <div class="content">
        <div class="pure-u-1 pure-u-lg-1-24"></div>
        <div class="pure-u-1 pure-u-md-10-24">
          <h1>
            CSL PLUS<sup>&trade;</sup> Patient Support Program:
          </h1>
          <h2>
            A personalized support program designed with patients in mind
          </h2>
          <p>
            CSL PLUS is dedicated to delivering the highest quality of support through one-to-one contact with our team
            of
            Registered Nurse Case Managers who are there for patients
            every step of the way.
          </p>
        </div>
        <div class="pure-u-1 pure-u-md-13-24">
          <video width="620" autoplay >
            <source src="assets/hero_video.mp4" type="video/mp4">s
          </video>
        </div>
      </div>

    </div>

  </div> -->


</div>
<section class="programpillars" id="programpillars">
  <div class="content-container">
    <div class="pure-g">
      <div class="pure-u-1">
        <h2>
          Program Pillars:
        </h2>
      </div>
      <div class="programpillars_box_wrapper">
        <div class="pure-u-1 pure-u-md-7-24">
          <div class="section" [class.divsec]="divsec">
            <div class="image_wrapper">
              <div class="img_section">
                <img src="/assets/img/education_training_icon.png" alt="Patient Program"
                     [class.trainingImg]="trainingImg" />
              </div>
            </div>
            <div class="text" (click)="showState()" (mouseleave)="hidestate()">
              <p>Education & Training</p>
            </div>
            <div class="textstuff" [@widthGrow]="state" [class.testvisible]="testvisible">
              <ul>
                <li>
                  CSL PLUS provides unlimited education, training and support to patients and caregivers
                </li>
              </ul>
              <div (click)="hidestate()" class="closewindow">
                <span class="fa fa-close"></span>&nbsp;<span>
                  Close
                  window
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="pure-u-1 pure-u-md-1-24"></div>
        <div class="pure-u-1 pure-u-md-7-24">
          <div class="section" [class.divsec2]="divsec2">
            <div class="image_wrapper">
              <div class="img_section">
                <img src="/assets/img/ongoing_support_icon.png" [class.supportImg]="supportImg"
                     alt="Patient Program" />
              </div>
            </div>
            <div class="text" (click)="showState2()" (mouseleave)="hidestate2()">
              <p>FOLLOW-UP & ONGOING SUPPORT</p>
            </div>
            <div class="textstuff2" [@widthGrow2]="state2" [class.testvisible2]="testvisible2">
              <ul>
                <li>
                  Easy sign-up with a fast and seamless onboarding experience
                </li>
                <li>Individual support provided by a registered nurse case manager</li>
              </ul>
              <div (click)="hidestate2()" class="closewindow">
                <span class="fa fa-close"></span>&nbsp;<span>
                  Close
                  window
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="pure-u-1 pure-u-md-1-24"></div>
        <div class="pure-u-1 pure-u-md-7-24">
          <div class="section" [class.divsec3]="divsec3">
            <div class="image_wrapper">
              <div class="img_section">
                <img src="/assets/img/helthcare_suport_icon.png" [class.healthcareImg]="healthcareImg"
                     alt="Patient Program" />
              </div>
            </div>
            <div class="text" (click)="showState3()" (mouseleave)="hidestate3()">
              <p>HEALTHCARE PROFESSIONAL SUPPORT</p>
            </div>
            <div class="textstuff3" [@widthGrow3]="state3" [class.testvisible3]="testvisible3">
              <ul>
                <li>
                  Personalized support to meet patient needs, and registration and follow-up assistance for healthcare professionals
                </li>
                <li>Constant contact with a nurse dedicated to case management for the entire treatment course</li>
              </ul>
              <div (click)="hidestate3()" class="closewindow">
                <span class="fa fa-close"> </span>&nbsp;<span>
                  Close
                  window
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="programpillars_text">
      <div class="pure-g">
        <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-5-24"></div>
        <div class="pure-u-1 pure-u-md-17-24 pure-u-lg-17-24">
          <h3>
            CSL Behring is a leader in biotechnology focused on innovating and delivering life-saving medicines for
            patients with unmet medical needs.
          </h3>
          <div>
            <div class="bullettext">
              <h4>
                Available for patients on:
              </h4>
              <div class="bulletpoint">
                <div class="pure-g logoalignment">
                  <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24">
                    <img src="/assets/img/hizentra-logo.svg" alt="Hizentra logo icon" />
                  </div>
                  <div class="pure-u-1 pure-u-md-1-24 pure-u-lg-1-24"></div>

                  <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24 align-center">
                    <img src="/assets/img/humatep-logo.png" alt="Humatep logo icon" />
                  </div>
                  <div class="pure-u-1 pure-u-md-1-24 pure-u-lg-1-24"></div>
                  <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24 align-center">
                    <img src="/assets/img/Hemgenix_Logo_EN.png" alt="Hemgenix logo icon" />
                  </div>
                </div>
                <div class="pure-g logoalignment">
                  <div class="pure-u-1 pure-u-md-7-24  pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24">
                    <img src="/assets/img/berinert-logo.svg" alt="Berinert logo icon" />
                  </div>
                  <div class="pure-u-1 pure-u-md-1-24 pure-u-lg-1-24"></div>

                  <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24">
                    <img src="/assets/img/haegarda-logo.svg" alt="Haegarda logo icon" />
                  </div>
                  <div class="pure-u-1 pure-u-md-1-24 pure-u-lg-1-24"></div>
                  <div class="pure-u-1 pure-u-md-7-24 pure-u-lg-7-24 pure-u-xl-7-24 pure-u-xxl-5-24">
                    <a href="https://www.andembry.ca/en/home/" target="_blank">
                      <img src="/assets/img/AndembryLogo_EN.png" alt="Andembry logo icon" />
                    </a>                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="desktophidden tablethidden">
            <div class="bullettext-mob">
              <h4>
                Available for patients on:
              </h4>
              <div class="bulletpoint">
                <div class="pure-g">
                  <div class="pure-u-1">
                    <ul>
                      <li>
                        <img src="/assets/img/hizentra-logo.svg" alt="Hizentra logo icon" />
                      </li>
                      <li>
                        <img src="/assets/img/berinert-logo.svg" alt="berinert logo icon" />
                      </li>
                      <li>
                        <img src="/assets/img/humatep-logo.png" alt="humate-p logo icom" />
                      </li>
                      <li>
                        <img src="/assets/img/haegarda-logo.svg" alt="haegarda logo icon" />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</section>
